import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的分步模板ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {}

export let infoRules = {
  title: [
    {...makeRule('请填写题目标题')},
  ],
}

export let questionRules = {
  title: [
    {...makeRule('请填写题目标题')},
  ],
  options: [
    {...makeRule('请至少添加一个选项', 'array')},
  ],
}
export let questionOptionRules = {
  title: [
    {...makeRule('请填写选项标题')},
  ],
  images: [
    {...makeRule('请上传图片', 'array')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/step-template/step-template.rules.js